import { render } from "./LyricsMightyOnes.vue?vue&type=template&id=9a8249ec&scoped=true"
import script from "./LyricsMightyOnes.vue?vue&type=script&lang=js"
export * from "./LyricsMightyOnes.vue?vue&type=script&lang=js"

import "./LyricsMightyOnes.vue?vue&type=style&index=0&id=9a8249ec&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a8249ec"]])

export default __exports__